import { api } from '../../../../components/common';
import { 
  PropertyWithDetails,
  CreatePropertyRequest,
  UpdatePropertyRequest,
  PropertySearchParams
} from '../types';
import { PaginatedResponse } from '../../../../types';

export const propertiesApi = {
  getAll: (params: PropertySearchParams = {}): Promise<PaginatedResponse<PropertyWithDetails>> => {
    // Build query params manually using URLSearchParams to properly serialize sorts array
    const queryParams = new URLSearchParams();
    
    if (params.search) queryParams.append('search', params.search);
    if (params.page) queryParams.append('page', params.page.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());
    
    // Handle multiple sorts - encode as JSON string
    if (params.sorts && params.sorts.length > 0) {
      queryParams.append('sorts', JSON.stringify(params.sorts));
    }
    
    // Handle multiple search fields - encode as JSON string
    if (params.fields && params.fields.length > 0) {
      queryParams.append('fields', JSON.stringify(params.fields));
    }
    
    return api.get(`/properties?${queryParams.toString()}`).then(res => res.data);
  },
    
  getById: (id: number): Promise<PropertyWithDetails> =>
    api.get(`/properties/${id}`).then(res => res.data),
    
  create: (property: CreatePropertyRequest): Promise<PropertyWithDetails> =>
    api.post('/properties', property).then(res => res.data),
    
  update: (id: number, property: UpdatePropertyRequest): Promise<PropertyWithDetails> =>
    api.put(`/properties/${id}`, property).then(res => res.data),
    
  delete: (id: number): Promise<void> =>
    api.delete(`/properties/${id}`).then(() => {}),

  addContact: (propertyId: number, contactId: number): Promise<void> =>
    api.post(`/properties/${propertyId}/contacts`, { contactId }).then(() => {}),

  removeContact: (propertyId: number, contactId: number): Promise<void> =>
    api.delete(`/properties/${propertyId}/contacts/${contactId}`).then(() => {}),
};

